var render = function render(){var _vm=this,_c=_vm._self._c;return _c('productIssueProgress',{attrs:{"title":"产品问题信息"}})
}
var staticRenderFns = []

export { render, staticRenderFns }